import * as Normalize from '../normalize';
import * as Types from './types';

export const normalize = Normalize.normFn<Types.GroupSelectionsObjSchema>(
  'group-selections',
  whole => whole
);

export const denormalize = Normalize.denormFn<Types.GroupSelectionsObjSchema>(
  part => part
);
